import React from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const teal = "#06d1c6";

const DATA_MANAGEMENT_CARDS = [
  {
    title: "File Import History",
    description: "Mailback file import log for CAMS, KFintech files",
    icon: "fa-folder-download",
    color: "#10b981",
  },
  {
    title: "Compliance Report",
    description: "PAN, Email id, KYC missing, IIN and UCC Communication mismatch",
    icon: "fa-clipboard-check",
    color: "#dc2626",
  },
  {
    title: "Duplicate Finder",
    description: "Find & bulk merge duplicate clients based on various combinations",
    icon: "fa-copy",
    color: "#7c3aed",
  },
  {
    title: "Campaign Log",
    description: "Log of all reports and alerts sent from Investwell",
    icon: "fa-envelope-open",
    color: "#10b981",
  },
  {
    title: "Create Transaction",
    description: "Add, Modify or delete any transaction done in MF, Shares, FD or Other Assets",
    icon: "fa-exchange-alt",
    color: "#ea580c",
  },
  {
    title: "Downloads",
    description: "Organized repository for downloading reports",
    icon: "fa-download",
    color: "#10b981",
  },
  {
    title: "User Defined Securities",
    description: "Configure categories, securities and price",
    icon: "fa-building",
    color: "#f59e0b",
  },
  {
    title: "AUM Reconciliation",
    description: "Exception report to see difference in Units in Investwell and RTA",
    icon: "fa-money-bill-wave",
    color: "#0ea5e9",
  },
  {
    title: "Transaction Reversals",
    description: "Transactions which have reversed by the RTA",
    icon: "fa-undo-alt",
    color: "#eab308",
  },
  {
    title: "Morningstar AWS Sync",
    description: "Sync Client portfolios with Morningstar",
    icon: "fa-sync-alt",
    color: "#0ea5e9",
  },
  {
    title: "CAS Import",
    description: "Import held away Mutual funds of your clients",
    icon: "fa-file-import",
    color: "#f59e0b",
  },
  {
    title: "Login History",
    description: "Login log with IP of all user sessions",
    icon: "fa-history",
    color: "#10b981",
  },
  {
    title: "Transmission process",
    description: "Transfer transactions from 1 folio to another for transmission and consolidation",
    icon: "fa-cog",
    color: "#ec4899",
  },
];

function DataCard({ title, description, icon, color }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: "16px",
        padding: "20px",
        background: "#fff",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
        border: "1px solid #e2e8f0",
        transition: "box-shadow 0.2s, border-color 0.2s",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(0, 0, 0, 0.12)";
        e.currentTarget.style.borderColor = teal;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.08)";
        e.currentTarget.style.borderColor = "#e2e8f0";
      }}
    >
      <div
        style={{
          width: 48,
          height: 48,
          minWidth: 48,
          borderRadius: "50%",
          background: color,
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "20px",
        }}
      >
        <i className={`fa-solid ${icon}`} aria-hidden />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <h6 className="mb-1" style={{ fontWeight: 700, color: "#0f172a", fontSize: "15px" }}>
          {title}
        </h6>
        <p className="mb-0" style={{ fontSize: "13px", color: "#64748b", lineHeight: 1.5 }}>
          {description}
        </p>
      </div>
    </div>
  );
}

export default function AdminDataManagement() {
  return (
    <div className="main-content">
      <style>{`
        .data-management-grid {
          grid-template-columns: repeat(2, 1fr);
        }
        @media (max-width: 768px) {
          .data-management-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
      <div className="page-wrapper page-settings">
        <div className="content">
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>Data Management</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Data Management
                </li>
              </ol>
            </nav>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "16px",
            }}
            className="data-management-grid"
          >
            {DATA_MANAGEMENT_CARDS.map((item) => (
              <DataCard
                key={item.title}
                title={item.title}
                description={item.description}
                icon={item.icon}
                color={item.color}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
